import React from 'react';
import { AlertIcon } from 'taboola-ultimate-ui';
import { EVENT_ICONS } from 'modules/PixelTester/config/pixelTesterConsts';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import styles from './eventCardHeader.module.scss';

export const formatTimestampToTodayString = timestampStr => {
    const timestamp = Number(timestampStr);
    if (!Number.isFinite(timestamp)) return null;

    return new Date(timestamp).toLocaleString(undefined, {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
};

export const EventCardHeader = ({ conversionName, eventType, eventData, hasConversions, isAutomaticallyFired }) => {
    const { eventName, eventTime, eventParameters } = eventData;
    const isUrlEvent = eventType === CONVERSION_TYPE.BASIC;
    const hasValidationErrors = !!eventParameters?.some(param => param.validationError != null);
    const showAlert = !isAutomaticallyFired && (!hasConversions || hasValidationErrors);
    const IconComponent = EVENT_ICONS[eventType];

    return (
        <div className={styles['header-container']}>
            <div className={styles['icon-title-container']}>
                <div className={styles['icon-background']}>
                    <IconComponent className={styles['icon']} />
                </div>
                <div className={styles['title-container']}>
                    {conversionName ? (
                        <span className={styles['title-text']}>{conversionName}</span>
                    ) : isAutomaticallyFired ? (
                        <div className={styles['source-label']}>
                            <FormattedMessage
                                id="pixel.tester.automatic.event.label"
                                defaultMessage="Automatically Fired"
                            />
                        </div>
                    ) : (
                        <FormattedMessage
                            id="pixel.tester.unknown.event.title"
                            defaultMessage="N/A"
                            className={styles['title-text']}
                        />
                    )}
                    {isUrlEvent ? (
                        <FormattedMessage
                            id="pixel.tester.url.subtitle"
                            defaultMessage="URL"
                            className={styles['subtitle-text']}
                        />
                    ) : (
                        <FormattedMessage
                            id="pixel.tester.event.subtitle"
                            defaultMessage="Event: {eventName}"
                            values={{ eventName }}
                            className={styles['subtitle-text']}
                        />
                    )}
                </div>
            </div>
            <div className={styles['date-issue-container']}>
                {showAlert && <AlertIcon className={styles['alert-icon']} />}
                <div className={styles['date']}>{formatTimestampToTodayString(eventTime)}</div>
            </div>
        </div>
    );
};
